import DownloadForm from './download-form';

class DownloadFormPopupEmail extends DownloadForm {

  protected nameSelector = '#popup-email form';
  protected nameInputSelector = 'input[type="email"]';
}

export default DownloadFormPopupEmail;
